/*
 * Component that shows a fullscreen dim overlay when any of its children turns
 * vibisible. The moment no children are visible, hids it itelf.
 * Children visibility *must* be controlled with `ng-if` for this component
 * to properly work.
 *
 * @example
 * ```
 * <dim-overlay>
 *   <span ng-if="sayHello">Hello!</span>
 * </dim-overlay>
 * ```
 */
import upp from 'app/app.module';

upp.directive('dimOverlay', function() {
    return {
        restrict: 'E',
        link: ($scope, $el) => {
            // $el[0] is the <dim-overlay>
            // $el[0].children[0] is the <ng-transclude>
            const target = $el[0].children[0]
            const observer = new MutationObserver((mututations) => {
                $scope.$evalAsync(() => {
                    $el.toggleClass('has-child',  target.children.length > 0);
                });
            });
            // Listen for child nodes changes (add/remove)
            observer.observe(target, { childList: true });
            // Stop observing after the element is destroyed
            $scope.$on('$destroy', () =>  observer.disconnect());
        },
        transclude: true,
        template: '<div ng-transclude></div>',
        styles: require('./dim-overlay.component.less'),
    };
});



// WEBPACK FOOTER //
// ./src/app/common/components/dim-overlay/dim-overlay.component.js